import { PageType } from '~/types/pages'

export const getPageSlug = (slugString: string, type: PageType = 'page') => {
  const slug = slugString.endsWith('/') ? slugString : `${slugString}/`

  if (type === 'page') {
    return `${slug}`
  }

  if (type === 'post') {
    return `/conteudo${slug}`
  }

  if (type === 'category') {
    return `/conteudo/categoria${slug}`
  }

  throw new Error('Page Type not Found')
}

export const getPageUrl = (slug: string, type: PageType = 'page') => {
  return `${process.env.siteUrl}${getPageSlug(slug, type)}`
}
